import Vue from 'vue'

import Router from 'vue-router';
import Home from '@/containers/Home';
import Regulation from '@/containers/Regulation';
import Calendar from '@/containers/Calendar';
import Ranking from '@/containers/Ranking';
import Contact from '@/containers/Contact';
import Draw from '@/containers/Draw';

import Banner from '@/components/Home/Banner';
import Category from '@/components/Home/Category';
import Registre from '@/components/Home/Registre';
import Clubes from '@/components/Home/Clubes';
import Normative from '@/components/Regulation/Normative';
import Schedules from '@/components/Calendar/Schedules';
import CRanking from '@/components/Ranking/CRanking';
import CContact from '@/components/Contact/CContact';
import CDraw from '@/components/Draw/CDraw';

import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'

Vue.use(Router)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)

export default new Router({
  mode: 'hash',
  routes: [
    //Home
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'inicio',
          components: {
            Banner,
            Category,
            Registre,
            Clubes
          }
        },
        {
          path: 'inicio',
          name: 'banner',
          components: {
            Banner,
            Category,
            Registre,
            Clubes
          }
        },
        {
          path: 'categorias',
          name: 'category',
          components: {
            Banner,
            Category,
            Registre,
            Clubes
          }
        },
        {
          path: 'registro',
          name: 'registre',
          components: {
            Banner,
            Category,
            Registre,
            Clubes
          }
        },
        {
          path: 'clubes',
          name: 'clubes',
          components: {
            Banner,
            Category,
            Registre,
            Clubes
          }
        }
      ]
    },
    //Reglamento
    {
      path: '/reglamento',
      component: Regulation,
      children: [
        {
          path: '',
          name: 'reglamento',
          components: {
            Normative
          }
        }
      ]
    },
    //Calendario
    {
      path: '/calendario',
      component: Calendar,
      children: [
        {
          path: '',
          name: 'calendario',
          components: {
            Schedules
          }
        }
      ]
    },
    //Ranking
    {
      path: '/ranking',
      component: Ranking,
      children: [
        {
          path: '',
          name: 'ranking',
          components: {
            CRanking
          }
        }
      ]
    },
    //Draw
    {
      path: '/draw',
      component: Draw,
      children: [
        {
          path: '',
          name: 'draw',
          components: {
            CDraw
          }
        }
      ]
    },
    //Contacto
    {
      path: '/contacto',
      component: Contact,
      children: [
        {
          path: '',
          name: 'contacto',
          components: {
            CContact
          }
        }
      ]
    },
    {
      path: '/:id',
      name: 'Routes',
      components: {
        default: Home,
      },
    },
  ],
})
